import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError, Observable } from 'rxjs';
import { ServiceLogEditViewModel } from '../models/ServiceLogEditViewModel';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

@Injectable({
  providedIn: 'root'
})
export class ServiceLogService {
  private url = '/api/serviceLog/';
  constructor(private http: HttpClient) { }
  get(id: number): Observable<any> {
    return this.http.get<any>(this.url + `get?id=${id}`, httpOptions)
      .pipe(catchError(error => { return throwError(error) }));
  }
  getUpdate(id: number): Observable<ServiceLogEditViewModel> {
    return this.http.get<ServiceLogEditViewModel>(this.url + `update?id=${id}`, httpOptions)
      .pipe(catchError(error => { return throwError(error) }));
  }
  save(something: ServiceLogEditViewModel): Observable<any> {
    return this.http.post<any>(this.url + 'create', something, httpOptions)
      .pipe(catchError(error => { return throwError(error) }));
  }
  update(something: ServiceLogEditViewModel): Observable<any> {
    return this.http.put<any>(this.url + 'update', something, httpOptions)
      .pipe(catchError(error => { return throwError(error) }));
  }
  delete(id: number): Observable<any> {
    return this.http.delete<any>(this.url + `delete?id=${id}`, httpOptions)
      .pipe(catchError(error => { return throwError(error) }));
  }
}
